// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__1WKP2","actionColumn":"ReferralSources_actionColumn__35zYY","textButton":"ReferralSources_textButton__36MG2"};